import api from 'api'
import useSWRInfinite from 'swr/infinite'

type SearchParamsType = {
  name_cont_any: string[]
  owner_addresses_state_or_owner_addresses_city_cont_any: string[]
}

/**
 * オーナー情報を取得するSWR
 * @params {SearchParamsType} search_params 検索 option
 * @params {number} limit 取得数
 */

export const useOwners = (search_params: SearchParamsType, limit?: number) => {
  const getKey = (pageIndex: number, previousPageData: Owner[]) => {
    if (previousPageData && !previousPageData.length) return null
    return { path: '/owners', search_params, page: pageIndex + 1 }
  }

  return useSWRInfinite(
    getKey,
    ({
      path,
      search_params,
      page,
    }: {
      path: string
      search_params: SearchParamsType
      page: number
    }) =>
      api
        .get<Owner[]>(path, {
          params: {
            search_params,
            page,
            limit,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            return {
              owners: res.data,
              xTotalCount: res.headers['x-total-count'],
            }
          } else throw res
        }),
    {
      initialSize: 1,
      revalidateOnFocus: false,
    },
  )
}
